/** API route map: URLS.Controller.SettingsServiceType */
export const SettingsServiceType = {
      name: 'ServiceType/',
      add: 'add',
      get: 'get',
      update: 'update',
      delete: 'delete',
};
